<template>
  <div>
    <button
      class="customer-service-flag-slideout-button noSelect focus:ring-2"
      tabindex="0"
      @click="toggleSlideout(true)"
    >
      <div class="flex-content">
        <svg
          data-v-24799fd9=""
          width="20"
          height="19"
          viewBox="0 0 20 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="customer-service-flag__icon"
        >
          <path
            d="M11.121 8.992H8.88a.285.285 0 00-.285.284v4.329c0 .157.127.284.285.284h2.242a.285.285 0 00.285-.284V9.276a.284.284 0 00-.285-.284h0zm-.284 4.328H9.163V9.56h1.674v3.76zM10 8.093c.822 0 1.491-.669 1.491-1.491 0-.822-.669-1.491-1.491-1.491-.822 0-1.491.669-1.491 1.49 0 .823.669 1.492 1.49 1.492zm0-2.413a.923.923 0 11-.002 1.845A.923.923 0 0110 5.68z"
            fill="#000"
            stroke="#000"
            stroke-width=".5"
          ></path>
          <path
            d="M10 18.27c4.836 0 8.77-3.934 8.77-8.77 0-4.836-3.934-8.77-8.77-8.77-4.836 0-8.77 3.934-8.77 8.77 0 4.836 3.934 8.77 8.77 8.77zm0-16.971c4.522 0 8.201 3.679 8.201 8.201S14.522 17.701 10 17.701 1.799 14.022 1.799 9.5 5.478 1.299 10 1.299z"
            fill="#000"
            stroke="#000"
            stroke-width=".5"
          ></path>
        </svg>
        {{ $t('global.customer_service') }}
      </div>
    </button>
    <FocusTrap v-if="showSlideout" :active="showSlideout">
      <section class="customer-service-flag">
        <Transition name="SlideRight">
          <article v-if="showSlideout" class="customer-service-flag__slideout">
            <div class="customer-service-flag__slideout-header">
              <h3
                class="flex-content customer-service-flag__slideout-header-container"
              >
                <svg
                  data-v-24799fd9=""
                  width="20"
                  height="19"
                  viewBox="0 0 20 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="customer-service-flag__icon"
                >
                  <path
                    d="M11.121 8.992H8.88a.285.285 0 00-.285.284v4.329c0 .157.127.284.285.284h2.242a.285.285 0 00.285-.284V9.276a.284.284 0 00-.285-.284h0zm-.284 4.328H9.163V9.56h1.674v3.76zM10 8.093c.822 0 1.491-.669 1.491-1.491 0-.822-.669-1.491-1.491-1.491-.822 0-1.491.669-1.491 1.49 0 .823.669 1.492 1.49 1.492zm0-2.413a.923.923 0 11-.002 1.845A.923.923 0 0110 5.68z"
                    fill="#000"
                    stroke="#000"
                    stroke-width=".5"
                  ></path>
                  <path
                    d="M10 18.27c4.836 0 8.77-3.934 8.77-8.77 0-4.836-3.934-8.77-8.77-8.77-4.836 0-8.77 3.934-8.77 8.77 0 4.836 3.934 8.77 8.77 8.77zm0-16.971c4.522 0 8.201 3.679 8.201 8.201S14.522 17.701 10 17.701 1.799 14.022 1.799 9.5 5.478 1.299 10 1.299z"
                    fill="#000"
                    stroke="#000"
                    stroke-width=".5"
                  ></path>
                </svg>
                {{ $t('global.customer_service') }}
              </h3>
              <button
                ref="firstFocusable"
                class="flex-content customer-service-flag__close-button noSelect"
                @click="toggleSlideout(false)"
              >
                <svg
                  data-v-24799fd9=""
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="customer-service-flag__close-icon"
                >
                  <path
                    d="M21 1L1 21M1 1l20 20"
                    stroke="#000"
                    stroke-width=".889"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </button>
            </div>
            <div class="customer-service-flag__slideout-content">
              <section class="customer-service-flag__slideout-content-section">
                <h4
                  class="flex-content customer-service-flag__slideout-content__headline"
                >
                  {{ $t('customer-service.title') }}
                </h4>
                <p class="customer-service-flag__slideout-content__paragraph">
                  {{ $t('customer-service.description') }}
                </p>
              </section>
              <section
                class="customer-service-flag__slideout-content-section--small"
              >
                <h5
                  class="flex-content customer-service-flag__slideout-content__headline--small"
                >
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="customer-service-flag__icon"
                  >
                    <path
                      d="M9.77002 18.54C14.6057 18.54 18.54 14.6057 18.54 9.77002C18.54 4.93386 14.6059 1 9.77002 1C4.93418 1 1 4.93418 1 9.77002C1 14.6059 4.93418 18.54 9.77002 18.54ZM9.77002 1.56891C14.2921 1.56891 17.9711 5.248 17.9711 9.77002C17.9711 14.2921 14.2922 17.9711 9.77002 17.9711C5.24781 17.9711 1.56891 14.2922 1.56891 9.77002C1.56891 5.24781 5.24781 1.56891 9.77002 1.56891Z"
                      fill="black"
                      stroke="black"
                      stroke-width="0.5"
                    />
                    <path
                      d="M8.1697 8.91843C8.81493 10.2672 9.80578 11.2556 11.1504 11.8992L11.5482 11.5017L11.8134 11.2365C12.0646 10.985 12.4269 10.9843 12.6774 11.2365C13.083 11.6422 13.4885 12.0479 13.8939 12.4537C14.125 12.6855 14.1472 12.9933 13.9359 13.2431C13.6369 13.5966 13.2784 13.8638 12.8209 13.9865C12.476 14.0792 12.1338 14.0506 11.7919 13.9845C10.8406 13.8004 10.0093 13.357 9.24713 12.7772C8.33271 12.0763 7.52737 11.2437 6.85743 10.3064C6.50806 9.82236 6.22993 9.2995 6.09495 8.71221C5.96713 8.15458 5.95213 7.59798 6.15119 7.05159C6.24404 6.79125 6.39459 6.55528 6.59157 6.36137C6.65224 6.30172 6.71154 6.24071 6.77153 6.18038C6.82632 6.12356 6.89195 6.07833 6.96454 6.04734C7.03713 6.01636 7.1152 6.00026 7.19412 6C7.27305 5.99975 7.35122 6.01535 7.42401 6.04586C7.4968 6.07638 7.56272 6.12119 7.61787 6.17765L8.8289 7.38801C9.09374 7.65285 9.09681 7.98757 8.83402 8.2548C8.61315 8.47805 8.38887 8.69926 8.1697 8.91843ZM11.1801 12.1872C11.0284 12.1023 10.8856 12.0208 10.7411 11.9421C9.92303 11.4966 9.20725 10.9247 8.66189 10.1618C8.38307 9.76987 8.1547 9.3421 7.90145 8.93206C7.87248 8.88502 7.90145 8.8656 7.92804 8.84003C8.17516 8.59292 8.42329 8.34716 8.66939 8.09903C8.84902 7.91735 8.84867 7.72409 8.66939 7.54685C8.26378 7.14101 7.85794 6.73539 7.45187 6.33001C7.41878 6.29582 7.3792 6.26855 7.33546 6.24981C7.29172 6.23106 7.24468 6.22121 7.19709 6.22083C7.14951 6.22045 7.10231 6.22955 7.05828 6.24759C7.01424 6.26564 6.97424 6.29226 6.9406 6.32592C6.87243 6.39069 6.80767 6.45784 6.74256 6.52532C6.56531 6.7028 6.43019 6.91783 6.34718 7.15453C6.20368 7.58162 6.19243 8.0179 6.26299 8.45862C6.34854 8.99205 6.56566 9.47571 6.86459 9.91916C7.61752 11.0361 8.53475 11.9983 9.63535 12.7789C10.3324 13.2731 11.0911 13.6354 11.9422 13.78C12.3226 13.8447 12.6921 13.8308 13.0496 13.6644C13.3111 13.5431 13.5166 13.3577 13.714 13.1531C13.899 12.964 13.9001 12.7782 13.714 12.589C13.3223 12.1974 12.9235 11.8126 12.5418 11.4117C12.3509 11.211 12.0949 11.257 11.9453 11.4162C11.6989 11.6797 11.4381 11.9292 11.1801 12.1872Z"
                      fill="black"
                      stroke="black"
                      stroke-width="0.6"
                    />
                  </svg>
                  {{ $t('customer-service.phone.by_phone') }}
                </h5>
                <p
                  class="customer-service-flag__slideout-content__paragraph--small"
                >
                  {{ $t('customer-service.phone.info') }}
                </p>
                <Phone type="orderPhone" />
                <Phone type="supportPhone" />
                <Phone type="sizeHelperPhone" />
              </section>
              <section
                class="customer-service-flag__slideout-content-section--small"
              >
                <h6
                  class="flex-content customer-service-flag__slideout-content__headline--small"
                >
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="customer-service-flag__icon"
                  >
                    <path
                      d="M9.77002 18.54C14.6057 18.54 18.54 14.6057 18.54 9.77002C18.54 4.93386 14.6059 1 9.77002 1C4.93418 1 1 4.93418 1 9.77002C1 14.6059 4.93418 18.54 9.77002 18.54ZM9.77002 1.56891C14.2921 1.56891 17.9711 5.248 17.9711 9.77002C17.9711 14.2921 14.2922 17.9711 9.77002 17.9711C5.24781 17.9711 1.56891 14.2922 1.56891 9.77002C1.56891 5.24781 5.24781 1.56891 9.77002 1.56891Z"
                      fill="black"
                      stroke="black"
                      stroke-width="0.5"
                    />
                    <path
                      d="M13.9571 13H5.51658C5.23237 13 5 12.7679 5 12.4839V7.51607C5 7.23214 5.23237 7 5.51658 7H13.9553C14.2413 7 14.4737 7.23214 14.4737 7.51607V12.4821C14.4737 12.7679 14.2413 13 13.9571 13Z"
                      stroke="black"
                      stroke-width="0.631579"
                      stroke-miterlimit="10"
                    />
                    <path
                      d="M6.42261 8.26367L9.7416 10.3163L13.0542 8.26367"
                      stroke="black"
                      stroke-width="0.631579"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                    />
                  </svg>
                  {{ $t('customer-service.by_email') }}
                </h6>
                <a
                  class="customer-service-flag__slideout-content__link--small"
                  :href="`mailto:${contactInfo.email}`"
                  >{{ contactInfo.email }}</a
                >
              </section>
              <section
                class="customer-service-flag__slideout-content-section--small"
              >
                <h6
                  class="flex-content customer-service-flag__slideout-content__headline--small"
                >
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="customer-service-flag__icon"
                  >
                    <path
                      d="M9.77002 18.54C14.6057 18.54 18.54 14.6057 18.54 9.77002C18.54 4.93386 14.6059 1 9.77002 1C4.93418 1 1 4.93418 1 9.77002C1 14.6059 4.93418 18.54 9.77002 18.54ZM9.77002 1.56891C14.2921 1.56891 17.9711 5.248 17.9711 9.77002C17.9711 14.2921 14.2922 17.9711 9.77002 17.9711C5.24781 17.9711 1.56891 14.2922 1.56891 9.77002C1.56891 5.24781 5.24781 1.56891 9.77002 1.56891Z"
                      fill="black"
                      stroke="black"
                      stroke-width="0.5"
                    />
                    <path
                      d="M6 9.98767V5.24183C6 5.04262 6.04145 5.00028 6.24021 5.00028C8.2751 5.00028 10.3103 5.00028 12.3458 5.00028C12.3916 4.99834 12.4374 5.00642 12.4798 5.02397C12.5222 5.04152 12.5603 5.06812 12.5913 5.1019C12.9559 5.47209 13.3233 5.83976 13.6934 6.20491C13.7261 6.23453 13.7519 6.27085 13.7692 6.31138C13.7865 6.35192 13.7949 6.3957 13.7937 6.43976C13.7919 9.21742 13.7919 11.9954 13.7937 14.7736C13.7937 14.9519 13.7492 15.0005 13.5709 15.0005H6.21748C6.04813 15.0005 6 14.9506 6 14.7803V9.98767ZM13.4693 14.6787V6.5231C13.1382 6.5231 12.815 6.5231 12.4924 6.5231C12.3106 6.5231 12.2638 6.47542 12.2638 6.29047C12.2638 6.06051 12.2638 5.8301 12.2638 5.60014V5.32383H6.32132V14.6787H13.4693Z"
                      fill="black"
                      stroke="black"
                      stroke-width="0.222831"
                    />
                    <path
                      d="M10.0929 11.2672H8.23449C8.1975 11.2672 8.14982 11.2787 8.12575 11.2605C8.07295 11.2272 8.0311 11.1792 8.00542 11.1223C7.9827 11.0466 8.03395 10.9886 8.11149 10.965C8.15105 10.9558 8.19171 10.9522 8.23227 10.9543H11.9714C11.9972 10.9527 12.0231 10.9527 12.0489 10.9543C12.1421 10.9668 12.2022 11.0158 12.1987 11.1147C12.1951 11.2137 12.1349 11.2627 12.04 11.2645C11.892 11.2676 11.7436 11.2645 11.5943 11.2645L10.0929 11.2672Z"
                      fill="black"
                      stroke="black"
                      stroke-width="0.222831"
                    />
                    <path
                      d="M10.0958 9.31387H8.2575C8.21671 9.31484 8.1759 9.31291 8.13539 9.30808C8.10085 9.30255 8.06928 9.28524 8.04605 9.25908C8.02282 9.23293 8.00935 9.19955 8.00794 9.1646C8.00652 9.12965 8.01724 9.09527 8.03828 9.06733C8.05931 9.03938 8.08937 9.01957 8.12335 9.01126C8.16742 9.003 8.21222 8.99927 8.25705 9.00012H11.956C11.9967 8.99943 12.0374 9.00212 12.0777 9.00815C12.1145 9.0136 12.1481 9.03237 12.172 9.06091C12.1958 9.08944 12.2084 9.12576 12.2073 9.16297C12.2062 9.20017 12.1915 9.23567 12.166 9.26275C12.1405 9.28983 12.1059 9.30659 12.0688 9.30986C12.0282 9.31343 11.9874 9.31476 11.9467 9.31387H10.0958Z"
                      fill="black"
                      stroke="black"
                      stroke-width="0.222831"
                    />
                  </svg>
                  {{ $t('customer-service.by_web') }}
                </h6>
                <NuxtLink
                  class="customer-service-flag__slideout-content__link--small"
                  :to="toLocalePath(contactInfo.url)"
                  >{{ $t('customer-service.to_form') }}
                </NuxtLink>
              </section>
            </div>
          </article>
        </Transition>
      </section>
    </FocusTrap>
  </div>
</template>

<script setup lang="ts">
import { FocusTrap } from 'focus-trap-vue'
import { CONTACT_INFO } from '~/config/contacts'
import type { Locale } from '~/config/locales'

const currentShop = useCurrentShop()
const showSlideout = ref<boolean>(false)
const { toLocalePath } = useRouteHelpers()
const firstFocusable = ref<HTMLElement | null>(null)

const contactInfo = computed(
  () => CONTACT_INFO[currentShop.value.locale as Locale],
)

function toggleSlideout(value: boolean): void {
  showSlideout.value = value
}

const handleKeyDown = (e: any) => {
  if (e.key === 'Escape') {
    toggleSlideout(false)
  }
}

watch(showSlideout, (newVal) => {
  if (newVal) {
    nextTick(() => {
      firstFocusable.value?.focus()
    })
  }
})

onMounted(() => {
  document.addEventListener('keyup', handleKeyDown)
})

onUnmounted(() => {
  document.removeEventListener('keyup', handleKeyDown)
})
</script>

<style lang="postcss" scoped>
/* Button */
.customer-service-flag-slideout-button {
  @apply fixed z-[60] bottom-[240px] lg:bottom-1/3 right-0
  bg-lightGold
  px-[20px] py-[6px] lg:px-[11px] lg:py-[9px]
  leading-[20px]
  text-sm lg:text-base
  shadow-lg
  font-medium
  origin-bottom-right
  -rotate-90
  rounded-t-lg
  max-w-[140px] max-h-[30px] lg:min-w-[140px] lg:max-h-[35px];

  box-shadow: 4.5px 4.5px 15px rgba(0, 0, 0, 0.3);
}

.customer-service-flag {
  @apply fixed top-0 right-0
  z-[60] h-full;
}
.flex-content {
  @apply flex justify-start items-center;
}

.customer-service-flag__icon {
  @apply mr-2.5
  w-[18px] h-[18px]
  inline-block;
}
.customer-service-flag__close-icon {
  @apply w-[14px] h-[14px] lg:w-[20px] lg:h-[20px]
  inline-block;
}

/* Slideout */
.customer-service-flag__slideout {
  @apply absolute top-0 right-0
  h-full
  w-screen
  bg-lightGold
  py-[30px] px-[20px]
  overflow-auto
  text-sm
  leading-5
  sm:p-8
  sm:w-[390px]
  sm:text-base
  sm:py-[31px]
  sm:px-[30px];
}
.customer-service-flag__slideout-header {
  @apply w-full
  flex
  justify-between
  items-center
  mb-[73px] lg:mb-[120px];
}
.customer-service-flag__slideout-header-container {
  @apply flex items-center;
}
.customer-service-flag__slideout-content {
  @apply flex
  flex-col
  tracking-wider
  gap-[40px] lg:gap-[51px];
}
.customer-service-flag__slideout-content-section {
  @apply flex
  flex-col
  gap-[7px];
}
.customer-service-flag__slideout-content-section--small {
  @apply flex
  flex-col
  gap-[20px];
}
.customer-service-flag__slideout-content__headline {
  @apply font-bold text-lg leading-[24px];
}
.customer-service-flag__slideout-content__paragraph {
  @apply font-medium text-sm leading-[19px] sm:text-base;
}
.customer-service-flag__slideout-content__link {
  @apply font-normal underline text-lg leading-[24px];
}
.customer-service-flag__slideout-content__headline--small {
  @apply font-bold text-base leading-[19px];
}
.customer-service-flag__slideout-content__paragraph--small {
  @apply font-medium text-xs leading-[16px] sm:text-sm;
}
.customer-service-flag__slideout-content__link--small {
  @apply font-normal underline text-base leading-[19px];
}
.noSelect {
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.noSelect:focus {
  outline: none !important;
}
</style>
